import { Component, ElementRef, ViewChild } from '@angular/core';
import { trigger, style, transition, animate, AnimationEvent } from '@angular/animations';
import { MegaMenuItem, MessageService } from 'primeng/api';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { MensajesService } from './services/mensajes.service';
import { Router } from '@angular/router';
import { SeguridadService } from './services/seguridad.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './services/auth.service';
import { EmpresaService } from './services/configuracion/empresa.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    animations: [
        trigger('topbarActionPanelAnimation', [
            transition(':enter', [
                style({opacity: 0, transform: 'scaleY(0.8)'}),
                animate('.12s cubic-bezier(0, 0, 0.2, 1)', style({ opacity: 1, transform: '*' })),
              ]),
              transition(':leave', [
                animate('.1s linear', style({ opacity: 0 }))
              ])
        ])
    ]
})
export class AppTopBarComponent {

    currentUser: any;
    iniciales: string;
    user:  Record<string, any>;
    urlImage = `${ environment.host }/get_file/empresa`;
    
    mostrarLogo: boolean = false ;

    showDialogPassword: boolean = false;
    formGroup: FormGroup;
    passType: string = 'password';

    constructor(
        public appMain: AppMainComponent, 
        public app: AppComponent,
        private mensajesService: MensajesService,
        private router: Router,
        private seguridadService: SeguridadService,
        private fb: FormBuilder,
        private messageService: MessageService,
        private authService: AuthService,
        private empresaService: EmpresaService
    ) {
        // this.currentUser = this.seguridadService.getCurrentUser();
        // this.setIniciales();
        // this.crearFormulario();
    }

      
    ngOnInit() {
        this.currentUser = this.seguridadService.getCurrentUser();
        if (this.currentUser) {
            this.setIniciales();
            this.crearFormulario();
            this.imagenLogo();
        }
        // document.addEventListener('click', (event) => {
        //     this.onDocumentClick(event);
        // });
    }

    crearFormulario() {
        this.formGroup = this.fb.group({
            oldPassword: [null, Validators.required],
            password1: [null, Validators.required],
            password2: [null, Validators.required]
        });
    }

    setIniciales() {
        const nombres = String(this.currentUser.nombre).split(" ");
        this.iniciales = nombres[0].charAt(0).toUpperCase();
        if ( nombres.length > 1 ){
            this.iniciales += nombres[1].charAt(0).toUpperCase();
        }
    }

    async imagenLogo() {
        const value = this.currentUser.id_empresa;
        if ( value ) {
            const res = await this.empresaService.get( value );
            if ( res.ok ) {
                this.user = res.resp;                                
            } else {
                this.messageService.add({severity: 'error', summary: res.msg, detail: res.resp});
            }
        }        
    }

    showPassword( passType: string ) {
        this.passType = passType;
    }

    activeItem: number;

    model: MegaMenuItem[] = [
        // {
        //     label: 'UI KIT',
        //     items: [
        //         [
        //             {
        //                 label: 'UI KIT 1',
        //                 items: [
        //                     { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
        //                     { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
        //                     { label: 'Float Label', icon: 'pi pi-fw pi-bookmark', routerLink: ['/uikit/floatlabel'] },
        //                     { label: 'Button', icon: 'pi pi-fw pi-mobile', routerLink: ['/uikit/button'] },
        //                     { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] }
        //                 ]
        //             }
        //         ],
        //         [
        //             {
        //                 label: 'UI KIT 2',
        //                 items: [
        //                     { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
        //                     { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
        //                     { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
        //                     { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
        //                     { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] }
        //                 ]
        //             }
        //         ],
        //         [
        //             {
        //                 label: 'UI KIT 3',
        //                 items: [
        //                     { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
        //                     { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
        //                     { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
        //                     { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
        //                     { label: 'Misc', icon: 'pi pi-fw pi-circle-off', routerLink: ['/uikit/misc'] }
        //                 ]
        //             }
        //         ]
        //     ]
        // },
        // {
        //     label: 'UTILITIES',
        //     items: [
        //         [
        //             {
        //                 label: 'UTILITIES 1',
        //                 items: [
        //                     { label: 'Icons', icon: 'pi pi-fw pi-prime', routerLink: ['utilities/icons'] },
        //                     { label: 'PrimeFlex', icon: 'pi pi-fw pi-desktop', url: 'https://www.primefaces.org/primeflex/', target: '_blank' }
        //                 ]
        //             }
        //         ],

        //     ]
        // }
    ];

    @ViewChild('searchInput') searchInputViewChild: ElementRef;

    onSearchAnimationEnd(event: AnimationEvent) {
        switch(event.toState) {
            case 'visible':
                this.searchInputViewChild.nativeElement.focus();
            break;
        }
    }

    cambiarContrasenha() {
        this.formGroup.reset();
        this.showDialogPassword = true;
    }

    async cancelarPass() {
        this.showDialogPassword = false;
        this.formGroup.reset();
    }

    async confirmarPass() {

        const value = this.formGroup.value;
        // controlamos que las nuevas contrasenhas sean iguales
        if ( value.password1 !== value.password2 ) {
            this.messageService.add({key: 'top-right', severity: 'error', summary: 'Favor verificar', detail: 'Las contraseñas no son iguales'});
            return;
        }

        // controlamos que sea de 6 de longitud
        if ( String(value.password1).length < 6 ) {
            this.messageService.add({key: 'top-right', severity: 'error', summary: 'Favor verificar', detail: 'Debe tener un minimo 6 caracteres'});
            return;
        }
        // console.log(this.formGroup.value);
        try {
            const value = this.formGroup.value;
            const res = await this.authService.cambiarContrasenha( this.currentUser.codigo, false, value.password1, value.oldPassword);
            // console.log(res);
            if ( res.ok ) {
                this.messageService.add({key: 'top-right', severity: 'success', summary: 'Contraseña Modificada', detail: 'Lo vamos a redirigir para que vuelva a iniciar sesión'});
                this.showDialogPassword = false;
                setTimeout( async () => {
                    await this.router.navigate(['auth','logout']);
                }, 3000);
            } else {
                this.messageService.add({key: 'top-right', severity: 'error', summary: res.msg, detail: res.resp});
            }
        } catch (error: any) {
            this.messageService.add({key: 'top-right', severity: 'error', summary: '', detail: error.message});
            return;
        }
        // this.showDialogPassword = false;
        
    }

    async salir() {
        const resp = await this.mensajesService.preguntar('Salir del Sistema', 'Esta seguro/a que desea salir?');
        if ( resp ) {
            await this.router.navigate(['auth','logout']);
        }
    }
}
